/* ============================================================
   What's My Size? — interactive size finder
   Reads the per-page structured size-chart data (custom.size_finder
   JSON metafield) embedded by snippets/size-finder.liquid and
   recommends a size by comparing the shopper's measurements against
   the chart's own ranges. No measurements are hardcoded here.
   ============================================================ */
(function () {
  'use strict';

  var CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var RULER_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v3M10 7v4M14 7v3M18 7v4"/></svg>';

  function round(n, dp) { var f = Math.pow(10, dp || 0); return Math.round(n * f) / f; }
  function toCanonical(val, dimUnit, imperial) {
    if (imperial) { return dimUnit === 'kg' ? val / 2.2046226218 : val * 2.54; }
    return val; // metric input already matches canonical (cm / kg)
  }
  function fromCanonical(val, dimUnit, imperial) {
    if (imperial) { return dimUnit === 'kg' ? val * 2.2046226218 : val / 2.54; }
    return val;
  }
  function unitLabel(dimUnit, imperial) {
    if (dimUnit === 'kg') return imperial ? 'lb' : 'kg';
    return imperial ? 'in' : 'cm';
  }
  function fmt(str, map) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return (map && k in map) ? map[k] : ''; });
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  /* Normalise a size token so a recommended size matches the product's control
     regardless of superficial differences: case/space, dash style (S–M vs S-M),
     and XXL/XXXL vs 2XL/3XL. Used ONLY to locate the matching variant control —
     never to change any stored value. */
  function normSize(s) {
    return String(s == null ? '' : s).trim().toLowerCase()
      .replace(/[‒–—−]/g, '-')      // figure/en/em dash, minus → hyphen
      .replace(/\s*-\s*/g, '-')                          // trim spaces around a hyphen
      .replace(/x{2,}l\b/g, function (m) { return (m.length - 1) + 'xl'; }) // xxl→2xl, xxxl→3xl
      .replace(/\s+/g, ' ');
  }

  /* ---- Recommendation engine -------------------------------------------------
     Compares each answered body measurement against every size's range for that
     dimension, tallies how many dimensions each size satisfies, and picks the
     best-supported size. Adjacent ties surface a "between sizes" result. -------- */
  function recommend(data, answers) {
    var sizes = data.sizes, n = sizes.length;
    var dims = (data.dimensions || []).filter(function (d) { return d.measure === 'body' && d.ranges; });
    var used = [];
    var count = new Array(n).fill(0);
    var dist = new Array(n).fill(0);
    var perDim = [];

    dims.forEach(function (d) {
      var v = answers[d.key];
      if (v == null || isNaN(v)) return;
      used.push(d);
      var contained = [];
      var dimDist = new Array(n).fill(0);
      for (var i = 0; i < n; i++) {
        var lo = d.ranges[i][0], hi = d.ranges[i][1];
        if (v >= lo && v <= hi) { count[i]++; contained.push(i); }
        else { var g = v < lo ? lo - v : v - hi; dist[i] += g; dimDist[i] = g; }
      }
      var pickLo, pickHi;
      if (contained.length) { pickLo = contained[0]; pickHi = contained[contained.length - 1]; }
      else {
        var best = 0; for (var j = 1; j < n; j++) { if (dimDist[j] < dimDist[best]) best = j; }
        pickLo = pickHi = best;
      }
      perDim.push({ dim: d, contained: contained, lo: pickLo, hi: pickHi });
    });

    if (!used.length) return { error: true };

    var maxCount = Math.max.apply(null, count);
    var candidates = [];
    var i2;
    if (maxCount > 0) {
      for (i2 = 0; i2 < n; i2++) if (count[i2] === maxCount) candidates.push(i2);
    } else {
      var minD = Math.min.apply(null, dist);
      for (i2 = 0; i2 < n; i2++) if (dist[i2] <= minD + 1e-9) candidates.push(i2);
    }

    var lo = Math.min.apply(null, candidates);
    var hi = Math.max.apply(null, candidates);
    var best = candidates.reduce(function (a, b) { return dist[b] < dist[a] ? b : a; }, candidates[0]);
    var contiguous = (hi - lo) === (candidates.length - 1);

    var result = { used: used, perDim: perDim, best: best, sizes: sizes };

    if (lo === hi) {
      result.kind = maxCount > 0 ? 'single' : 'closest';
      result.index = lo;
      // Outside-range nuance when the only match is a chart endpoint reached by distance.
      if (maxCount === 0) {
        if (lo === n - 1) result.outside = 'high';
        else if (lo === 0) result.outside = 'low';
      }
    } else if (contiguous) {
      result.kind = 'between';
      result.loIndex = lo; result.hiIndex = hi;
    } else {
      // Measurements point to non-adjacent sizes — fall back to best-supported, flag as approximate.
      result.kind = 'closest';
      result.index = best;
    }
    return result;
  }

  /* ---- GORTEKS bra engine (engine: 'bra-uk') --------------------------------
     A 2-D chart lookup, NOT a generic difference formula: underbust → UK band,
     then bust (absolute cm) → UK cup within that band. Ranges come straight from
     the GORTEKS chart carried in the metafield. Output is the canonical UK size
     (e.g. "34DD"); it never guesses outside the chart. -------------------------- */
  function bandForUnderbust(data, under) {
    var bands = data.bands || [];
    for (var i = 0; i < bands.length; i++) {
      if (under >= bands[i].under[0] && under <= bands[i].under[1]) return bands[i];
    }
    return null;
  }
  function recommendBra(data, answers) {
    var under = answers.underbust, bust = answers.bust;
    if (under == null || isNaN(under) || bust == null || isNaN(bust)) return { error: true };
    var band = bandForUnderbust(data, under);
    if (!band) return { outOfChart: true };            // underbust outside the chart
    if (bust <= under) return { invalid: true };        // anatomically impossible
    if (bust < band.cupA_lo || bust > band.cupA_lo + 20) return { outOfChart: true };
    var cups = data.cups || [];
    var idx = Math.floor((bust - band.cupA_lo) / 2);    // 2 cm per cup step
    if (idx < 0) return { outOfChart: true };
    if (idx > cups.length - 1) idx = cups.length - 1;   // clamp GG top boundary
    return { size: String(band.uk) + cups[idx], band: band, cupIndex: idx };
  }
  /* Sister sizes: trade one band for one cup (same cup volume). Ordered closest-first. */
  function braSisters(data, band, cupIndex) {
    var bands = data.bands || [], cups = data.cups || [], bi = -1;
    for (var k = 0; k < bands.length; k++) { if (bands[k].uk === band.uk) { bi = k; break; } }
    var out = [], steps = [[-1, 1], [1, -1], [-2, 2], [2, -2]];
    steps.forEach(function (s) {
      var nb = bi + s[0], nc = cupIndex + s[1];
      if (bi >= 0 && nb >= 0 && nb < bands.length && nc >= 0 && nc < cups.length) {
        out.push(String(bands[nb].uk) + cups[nc]);
      }
    });
    return out;
  }

  /* ---- Component ------------------------------------------------------------- */
  function SizeFinder(root) {
    var dataEl = root.querySelector('[data-sf-data]');
    var i18nEl = root.querySelector('[data-sf-i18n]');
    var chartTpl = root.querySelector('[data-sf-chart]');
    if (!dataEl || !i18nEl) return;
    var data, t;
    try { data = JSON.parse(dataEl.textContent); t = JSON.parse(i18nEl.textContent); }
    catch (e) { return; }
    if (!data) return;
    var isBra = data.engine === 'bra-uk';
    if (isBra) { if (!Array.isArray(data.bands) || !data.bands.length) return; }
    else if (!Array.isArray(data.sizes) || !data.sizes.length) return;

    var imperial = false;
    var dialog = null, resultBox = null, errorBox = null, inputs = {};
    var lastBraResult = null;

    var trigger = root.querySelector('[data-sf-open]');
    if (trigger) trigger.addEventListener('click', open);

    // Keep an open bra result in sync when the shopper flips the PDP UK|EU switch.
    if (isBra) {
      document.addEventListener('spanties:sizesystem', function () {
        if (lastBraResult && dialog && dialog.open) renderBraResult(lastBraResult);
      });
    }

    function bodyDims() {
      return (data.dimensions || []).filter(function (d) { return d.measure === 'body' && (isBra || d.ranges); });
    }
    function dimLabel(d) { return (t.dims && t.dims[d.key]) || d.label || d.key; }
    function dimHint(d) { return d.hint || (t.hints && t.hints[d.key]) || ''; }

    function build() {
      dialog = el('dialog', 'size-finder__dialog');
      dialog.setAttribute('aria-label', t.title || 'Find your size');
      var inner = el('div', 'size-finder__inner');

      var header = el('div', 'size-finder__header');
      header.appendChild(el('h2', 'size-finder__title', t.title || 'Find your size'));
      var close = el('button', 'size-finder__close', CLOSE_SVG);
      close.type = 'button';
      close.setAttribute('aria-label', t.close || 'Close');
      close.addEventListener('click', function () { dialog.close(); });
      header.appendChild(close);

      var body = el('div', 'size-finder__body');
      if (t.intro) body.appendChild(el('p', 'size-finder__intro', t.intro));

      // Units toggle
      var units = el('div', 'size-finder__units');
      units.appendChild(el('span', 'size-finder__units-label', t.units_label || 'Units'));
      var seg = el('div', 'size-finder__segmented');
      var segM = el('button', 'size-finder__seg', t.metric || 'Metric');
      var segI = el('button', 'size-finder__seg', t.imperial || 'Imperial');
      segM.type = segI.type = 'button';
      segM.setAttribute('aria-pressed', 'true'); segI.setAttribute('aria-pressed', 'false');
      segM.addEventListener('click', function () { setImperial(false, segM, segI); });
      segI.addEventListener('click', function () { setImperial(true, segM, segI); });
      seg.appendChild(segM); seg.appendChild(segI);
      units.appendChild(seg);
      body.appendChild(units);

      // Questions
      var fields = el('div', 'size-finder__fields');
      inputs = {};
      bodyDims().forEach(function (d) {
        var field = el('div', 'size-finder__field');
        var head = el('div', 'size-finder__field-head');
        head.appendChild(el('label', 'size-finder__label', dimLabel(d)));
        if (!isBra && bodyDims().length > 1) head.appendChild(el('span', 'size-finder__optional', t.optional || 'optional'));
        field.appendChild(head);
        var hint = dimHint(d);
        if (hint) field.appendChild(el('p', 'size-finder__hint', hint));
        var wrap = el('div', 'size-finder__input-wrap');
        var input = el('input', 'size-finder__input');
        input.type = 'number'; input.inputMode = 'decimal'; input.min = '0'; input.step = 'any';
        input.setAttribute('aria-label', dimLabel(d));
        var uspan = el('span', 'size-finder__unit', unitLabel(d.unit, imperial));
        wrap.appendChild(input); wrap.appendChild(uspan);
        field.appendChild(wrap);
        input.addEventListener('input', function () { if (errorBox) errorBox.textContent = ''; });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); compute(); } });
        inputs[d.key] = { input: input, unitSpan: uspan, dim: d };
        fields.appendChild(field);
      });
      body.appendChild(fields);

      errorBox = el('p', 'size-finder__error');
      errorBox.setAttribute('role', 'alert');
      body.appendChild(errorBox);

      var actions = el('div', 'size-finder__actions');
      var submit = el('button', 'size-finder__submit', t.calculate || 'Show my size');
      submit.type = 'button';
      submit.addEventListener('click', compute);
      var reset = el('button', 'size-finder__reset', t.reset || 'Start over');
      reset.type = 'button';
      reset.addEventListener('click', resetAll);
      actions.appendChild(submit); actions.appendChild(reset);
      body.appendChild(actions);

      resultBox = el('div', 'size-finder__result');
      resultBox.setAttribute('aria-live', 'polite');
      body.appendChild(resultBox);

      inner.appendChild(header); inner.appendChild(body);
      dialog.appendChild(inner);
      root.appendChild(dialog);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }

    function setImperial(val, segM, segI) {
      if (val === imperial) return;
      Object.keys(inputs).forEach(function (k) {
        var it = inputs[k], raw = parseFloat(it.input.value);
        if (!isNaN(raw)) {
          var canon = toCanonical(raw, it.dim.unit, imperial); // old state
          it.input.value = round(fromCanonical(canon, it.dim.unit, val), 1);
        }
        it.unitSpan.textContent = unitLabel(it.dim.unit, val);
      });
      imperial = val;
      segM.setAttribute('aria-pressed', String(!val));
      segI.setAttribute('aria-pressed', String(val));
    }

    function resetAll() {
      Object.keys(inputs).forEach(function (k) { inputs[k].input.value = ''; });
      if (errorBox) errorBox.textContent = '';
      if (resultBox) resultBox.innerHTML = '';
    }

    function collect() {
      var answers = {};
      Object.keys(inputs).forEach(function (k) {
        var raw = parseFloat(inputs[k].input.value);
        if (!isNaN(raw)) answers[k] = toCanonical(raw, inputs[k].dim.unit, imperial);
      });
      return answers;
    }

    function sizeName(i) { return data.sizes[i]; }

    function chipText(pd) {
      var label = dimLabel(pd.dim);
      var s = pd.lo === pd.hi ? sizeName(pd.lo) : (sizeName(pd.lo) + '–' + sizeName(pd.hi));
      if (!pd.contained.length) s = '~' + s;
      return label + ': ' + s;
    }

    function garmentFor(index) {
      var rows = (data.dimensions || []).filter(function (d) { return d.measure === 'garment' && d.values; });
      if (!rows.length) return null;
      var list = el('ul', 'size-finder__garment-list');
      rows.forEach(function (d) {
        var v = d.values[index];
        if (v == null) return;
        var li = el('li');
        li.appendChild(el('span', null, dimLabel(d)));
        li.appendChild(el('span', null, round(fromCanonical(v, d.unit, imperial), 1) + ' ' + unitLabel(d.unit, imperial)));
        list.appendChild(li);
      });
      if (!list.children.length) return null;
      var det = el('details', 'size-finder__garment');
      det.appendChild(el('summary', null, fmt(t.garment_heading || 'Garment measurements — size {size}', { size: sizeName(index) })));
      det.appendChild(list);
      return det;
    }

    function compute() {
      var answers = collect();
      if (errorBox) errorBox.textContent = '';
      if (isBra) {
        // Bras need BOTH measurements to place band + cup.
        if (answers.underbust == null || answers.bust == null) {
          if (errorBox) errorBox.textContent = t.need_both || t.need_input || 'Enter both measurements.';
          return;
        }
        renderBraResult(recommendBra(data, answers));
        return;
      }
      if (!Object.keys(answers).length) { if (errorBox) errorBox.textContent = t.need_input || 'Enter at least one measurement.'; return; }
      var r = recommend(data, answers);
      if (r.error) { if (errorBox) errorBox.textContent = t.need_input; return; }
      renderResult(r);
    }

    function renderResult(r) {
      resultBox.innerHTML = '';
      var card = el('div', 'size-finder__result-card');
      var msg = '', sizeHtml = '', garmentIndex = r.best;

      if (r.kind === 'between') {
        card.appendChild(el('p', 'size-finder__result-label', t.between_heading || t.result_heading));
        sizeHtml = sizeName(r.loIndex) + '<span class="sf-sep">/</span>' + sizeName(r.hiIndex);
        var tmpl = data.between_rule === 'larger' ? (t.between_larger || t.between_either) : (t.between_either);
        msg = fmt(tmpl, { smaller: sizeName(r.loIndex), larger: sizeName(r.hiIndex) });
        garmentIndex = data.between_rule === 'larger' ? r.hiIndex : r.loIndex;
      } else {
        card.appendChild(el('p', 'size-finder__result-label', t.result_heading || 'Your recommended size'));
        sizeHtml = sizeName(r.index);
        if (r.kind === 'closest') {
          if (r.outside === 'high') msg = fmt(t.outside_high, { size: sizeName(r.index) });
          else if (r.outside === 'low') msg = fmt(t.outside_low, { size: sizeName(r.index) });
          else msg = t.closest || '';
        }
        garmentIndex = r.index;
      }

      card.appendChild(el('p', 'size-finder__result-size', sizeHtml));
      if (msg) card.appendChild(el('p', 'size-finder__result-msg', msg));

      // Catalogue-aware SELECT for the recommended size — consistent across EVERY
      // What's My Size tool. On by default; a chart can opt out with connect:false.
      // appendConnectActions only shows an active SELECT when a matching, in-stock
      // control exists; otherwise it shows the sold-out / not-available message.
      if (data.connect !== false) appendConnectActions(card, r);

      // Per-measurement breakdown chips
      if (r.perDim && r.perDim.length) {
        var chips = el('div', 'size-finder__chips');
        r.perDim.forEach(function (pd) { chips.appendChild(el('span', 'size-finder__chip', chipText(pd))); });
        card.appendChild(chips);
      }

      var garment = garmentFor(garmentIndex);
      if (garment) card.appendChild(garment);

      var footer = el('div', 'size-finder__footer');
      if (chartTpl) {
        var viewBtn = el('button', 'size-finder__view-chart', t.view_chart || 'View full size chart');
        viewBtn.type = 'button';
        viewBtn.addEventListener('click', function () {
          if (viewBtn.dataset.shown) return;
          viewBtn.dataset.shown = '1';
          var holder = el('div', 'size-finder__chart-holder rte');
          holder.innerHTML = chartTpl.innerHTML;
          holder.querySelectorAll('img').forEach(function (im) { im.loading = 'lazy'; im.style.maxWidth = '100%'; im.style.height = 'auto'; });
          footer.insertBefore(holder, viewBtn.nextSibling);
          viewBtn.style.display = 'none';
        });
        footer.appendChild(viewBtn);
      }
      if (t.disclaimer) footer.appendChild(el('p', 'size-finder__disclaimer', t.disclaimer));
      card.appendChild(footer);

      resultBox.appendChild(card);
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ---- Bra result (catalogue-aware + variant select + UK/EU display) ------- */
    function cssEscape(v) {
      if (window.CSS && CSS.escape) return CSS.escape(v);
      return String(v).replace(/["\\]/g, '\\$&');
    }
    // Locate the existing size radio on the PDP for a recommended size.
    // 1) by CANONICAL value first — bras recommend the canonical UK value (e.g. 34DD)
    //    and their label may be EU-relabelled (75E), so value-match keeps selection
    //    canonical regardless of the UK/EU display.
    // 2) then by the VISIBLE button label — tights/hold-ups store GATTA codes as the
    //    value (3-M, 1-2) but display "M"/"S-M" via the size-label snippet, so the
    //    recommendation (a display label) matches the label, and we return that
    //    control's own <input> (whose value stays untouched).
    function findSizeInput(size) {
      var t = normSize(size);
      var inputs = [].slice.call(document.querySelectorAll('.variant-input input'));
      for (var i = 0; i < inputs.length; i++) { if (normSize(inputs[i].value) === t) return inputs[i]; }
      var divs = [].slice.call(document.querySelectorAll('.variant-input'));
      for (var j = 0; j < divs.length; j++) {
        var lbl = divs[j].querySelector('.variant__button-label') || divs[j].querySelector('label');
        if (lbl && normSize(lbl.textContent) === t) return divs[j].querySelector('input');
      }
      return null;
    }
    function isSoldOut(input) {
      if (!input) return false;
      if (input.classList.contains('disabled')) return true;
      var div = input.closest('.variant-input');
      var lbl = div && div.querySelector('label');
      return !!(lbl && lbl.classList.contains('disabled'));
    }
    function closeDialog() {
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    }
    // Reuse the theme's own radio change behaviour — no variant IDs, no duplicated logic.
    function selectVariant(size) {
      var input = findSizeInput(size);
      if (input && !isSoldOut(input) && !input.checked) input.click();
      closeDialog();
    }
    function appendChartLink(card) {
      if (!chartTpl) return;
      var footer = el('div', 'size-finder__footer');
      var viewBtn = el('button', 'size-finder__view-chart', t.view_chart || 'View full size chart');
      viewBtn.type = 'button';
      viewBtn.addEventListener('click', function () {
        if (viewBtn.dataset.shown) return;
        viewBtn.dataset.shown = '1';
        var holder = el('div', 'size-finder__chart-holder rte');
        holder.innerHTML = chartTpl.innerHTML;
        holder.querySelectorAll('img').forEach(function (im) { im.loading = 'lazy'; im.style.maxWidth = '100%'; im.style.height = 'auto'; });
        footer.insertBefore(holder, viewBtn.nextSibling);
        viewBtn.style.display = 'none';
      });
      footer.appendChild(viewBtn);
      card.appendChild(footer);
    }
    // Closest AVAILABLE sister size, clearly labelled as an alternative (never a silent swap).
    function appendSister(container, r) {
      if (!r.band || r.cupIndex == null) return;
      var sisters = braSisters(data, r.band, r.cupIndex);
      for (var i = 0; i < sisters.length; i++) {
        var inp = findSizeInput(sisters[i]);
        if (inp && !isSoldOut(inp)) {
          var target = sisters[i];
          var sdisp = window.SpantiesBraSize ? window.SpantiesBraSize.toDisplay(target) : target;
          var wrap = el('div', 'size-finder__sister');
          wrap.appendChild(el('span', 'size-finder__sister-label', t.closest_available || 'Closest available in this style'));
          var sbtn = el('button', 'size-finder__select size-finder__select--alt', fmt(t.select_action || 'Select {size}', { size: sdisp }));
          sbtn.type = 'button';
          sbtn.setAttribute('aria-label', fmt(t.select_action || 'Select {size}', { size: target }));
          sbtn.addEventListener('click', function () { selectVariant(target); });
          wrap.appendChild(sbtn);
          container.appendChild(wrap);
          return;
        }
      }
    }
    function renderBraResult(r) {
      lastBraResult = r;
      resultBox.innerHTML = '';
      if (!r || r.error) { if (errorBox) errorBox.textContent = t.need_both || t.need_input; return; }

      var card = el('div', 'size-finder__result-card');
      if (r.invalid || r.outOfChart) {
        card.appendChild(el('p', 'size-finder__result-msg', t.not_determined || "We couldn't determine a size from these measurements. Please check your measurements or view our Size Guide."));
        appendChartLink(card);
        resultBox.appendChild(card);
        resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        return;
      }

      var uk = r.size;                                              // canonical, e.g. "34DD"
      var bss = window.SpantiesBraSize || null;
      var euEquiv = bss ? bss.toEU(uk) : null;                       // "75E"
      var disp = bss ? bss.toDisplay(uk) : uk;                       // 75E if EU active, else 34DD

      card.appendChild(el('p', 'size-finder__result-label', t.result_heading || 'Your recommended size'));
      card.appendChild(el('p', 'size-finder__result-size', disp));
      if (euEquiv && euEquiv !== uk) {
        card.appendChild(el('p', 'size-finder__equiv', fmt(t.equiv_line || 'UK {uk} · EU {eu}', { uk: uk, eu: euEquiv })));
      }

      var actions = el('div', 'size-finder__bra-actions');
      var input = findSizeInput(uk);
      if (input && !isSoldOut(input)) {
        var selectBtn = el('button', 'size-finder__select btn', fmt(t.select_action || 'Select {size}', { size: disp }));
        selectBtn.type = 'button';
        selectBtn.setAttribute('aria-label', fmt(t.select_action || 'Select {size}', { size: uk }));
        selectBtn.addEventListener('click', function () { selectVariant(uk); });
        actions.appendChild(selectBtn);
      } else if (input) {
        actions.appendChild(el('p', 'size-finder__avail-note', fmt(t.soldout_in_style || 'Your recommended size is {size}, but it is currently sold out in this style.', { size: disp })));
        appendSister(actions, r);
      } else {
        actions.appendChild(el('p', 'size-finder__avail-note', fmt(t.unavailable_in_style || 'Your recommended size is {size}, but this size is not available in this style.', { size: disp })));
        appendSister(actions, r);
      }
      card.appendChild(actions);

      appendChartLink(card);
      if (t.disclaimer) card.appendChild(el('p', 'size-finder__disclaimer', t.disclaimer));
      resultBox.appendChild(card);
      resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Generic catalogue-aware actions for connect-enabled range charts (e.g. GORTEKS
     // underwear hips→size). Reuses the same variant-selection helpers as the bra path.
    function appendConnectActions(card, r) {
      var primary;
      if (r.kind === 'between') {
        primary = data.between_rule === 'larger' ? sizeName(r.hiIndex) : sizeName(r.loIndex);
      } else if (typeof r.index === 'number') {
        primary = sizeName(r.index);
      } else { return; }
      var actions = el('div', 'size-finder__bra-actions');
      var input = findSizeInput(primary);
      if (input && !isSoldOut(input)) {
        var b = el('button', 'size-finder__select btn', fmt(t.select_action || 'Select {size}', { size: primary }));
        b.type = 'button';
        b.setAttribute('aria-label', fmt(t.select_action || 'Select {size}', { size: primary }));
        b.addEventListener('click', function () { selectVariant(primary); });
        actions.appendChild(b);
      } else if (input) {
        actions.appendChild(el('p', 'size-finder__avail-note', fmt(t.soldout_in_style || 'Your recommended size is {size}, but it is currently sold out in this style.', { size: primary })));
        appendNearest(actions, primary);
      } else {
        actions.appendChild(el('p', 'size-finder__avail-note', fmt(t.unavailable_in_style || 'Your recommended size is {size}, but this size is not available in this style.', { size: primary })));
        appendNearest(actions, primary);
      }
      card.appendChild(actions);
    }
    // Nearest AVAILABLE size on this product, stepping outward through data.sizes.
    function appendNearest(container, sizeStr) {
      var idx = data.sizes.indexOf(sizeStr);
      if (idx < 0) return;
      for (var d = 1; d < data.sizes.length; d++) {
        var cand = [idx - d, idx + d];
        for (var c = 0; c < cand.length; c++) {
          var j = cand[c];
          if (j < 0 || j >= data.sizes.length) continue;
          var inp = findSizeInput(data.sizes[j]);
          if (inp && !isSoldOut(inp)) {
            var target = data.sizes[j];
            var wrap = el('div', 'size-finder__sister');
            wrap.appendChild(el('span', 'size-finder__sister-label', t.closest_available || 'Closest available in this style'));
            var sb = el('button', 'size-finder__select size-finder__select--alt', fmt(t.select_action || 'Select {size}', { size: target }));
            sb.type = 'button';
            sb.setAttribute('aria-label', fmt(t.select_action || 'Select {size}', { size: target }));
            sb.addEventListener('click', function () { selectVariant(target); });
            wrap.appendChild(sb);
            container.appendChild(wrap);
            return;
          }
        }
      }
    }

    function open() {
      if (!dialog) build();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      var first = dialog.querySelector('.size-finder__input');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-size-finder]').forEach(function (root) {
      if (root.dataset.sfInit) return;
      root.dataset.sfInit = '1';
      SizeFinder(root);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    // Re-scan when Shopify theme editor injects/reloads sections.
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  (typeof window !== 'undefined' ? window : globalThis).SpantiesSizeFinder = { init: init, recommend: recommend };
})();
